import { FormatNumberOptions, FormattedNumber } from 'react-intl';

import { toMoneyInfo } from 'utils/ticket.utils';

import { DEFAULT_CURRENCY } from 'constants/tickets.constants';
import { MoneyInfoFragment } from 'types/api/tickets.types';

interface Props extends FormatNumberOptions {
  price: MoneyInfoFragment | number | undefined;
}

const FormattedMoneyInfo = ({
  price,
  currency = DEFAULT_CURRENCY,
  ...options
}: Props) => {
  if (!price) return null;
  const moneyInfo = toMoneyInfo(price, currency);
  if (!moneyInfo) return null;

  return (
    <FormattedNumber
      value={moneyInfo.amount}
      currency={moneyInfo.currency}
      style="currency"
      minimumFractionDigits={2}
      {...options}
    />
  );
};

export default FormattedMoneyInfo;
